import type { PropsWithChildren, ReactNode } from "react";

import { Box } from "../../../../../../mads";

import { StyleSheet } from "react-native";

export type JobHeaderActionsProps = PropsWithChildren<{
  compact?: boolean;
  primaryApply: ReactNode;
  secondaryApply?: ReactNode | undefined;
  saveJob?: ReactNode | undefined;
  shareJob?: ReactNode | undefined;
  dislikeJob?: ReactNode | undefined;
}>;

export const JobHeaderActions: React.FC<JobHeaderActionsProps> = ({
  compact = false,
  primaryApply,
  secondaryApply,
  saveJob,
  shareJob,
  dislikeJob,
}) => {
  return (
    <Box sx={[styles.actionsRow, compact && styles.compactActionsRow]}>
      <Box sx={[styles.primaryButton, compact && styles.compactPrimaryButton]}>{primaryApply}</Box>
      <Box>{secondaryApply}</Box>
      <Box>{saveJob}</Box>
      <Box>{dislikeJob}</Box>
      <Box>{shareJob}</Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  actionsRow: {
    display: "flex",
    flexDirection: "row",
    columnGap: 12,
    paddingTop: 16,
    paddingBottom: 24,
  },
  compactActionsRow: {
    alignItems: "center",
    columnGap: 8,
    flexWrap: "wrap",
    paddingBottom: 16,
    paddingTop: 16,
    rowGap: 8,
  },
  compactPrimaryButton: {
    flexShrink: 1,
    minWidth: 0,
  },
  primaryButton: {},
});
